import React from "react";
import styles from'./CustomTabComponent.module.css';
import { tabs } from "./livechat.data";

const CustomTabComponent = ({ tabValue, handleTabChange }) => {
  return (
    <div className={styles.tabContainer}>
      {/* Map through the tabs array */}
      {tabs.map((tab, index) => (
        <div className={`${styles.tab} ${tabValue=== index ? styles.activeTab: ''}`} key={index} onClick={()=> handleTabChange(null,index)}>
          {/* tab name */}
          <span className={styles.tabName}>
            {tab}
          </span>
        </div>
      ))}
    </div>
  );
};

export default CustomTabComponent;
